'use strict';

var React = require('react');
var styleHelper = require('../../helper/styleHelper');
var util = require('../../helper/util');

/// Wifi图标路
var WIFI = 'M236,178.973l2.09,2.128l2.09-2.128c-0.535-0.545-1.273-0.882-2.09-0.882S236.535,178.428,236,178.973z '
  + 'M234,176.936l1.045,1.063c0.78-0.794,1.857-1.287,3.045-1.287s2.265,0.492,3.045,1.287l1.045-1.063'
  + ' c-1.048-1.067-2.494-1.729-4.09-1.729S235.048,175.869,234,176.936z '
  + 'M238.09,172.104c-2.436,0-4.644,1.009-6.243,2.638l1.045,1.064 c1.331-1.357,3.171-2.197,5.198-2.197'
  + 's3.867,0.84,5.198,2.197l1.044-1.064C242.733,173.114,240.525,172.104,238.09,172.104z';

/// 安卓Home键路
var ANDROID_HOME = 'M312.892,857.672h-14.318c-1.368,0-2.481-1.111-2.481-2.48v-2.992c0-0.266,0.105-0.52,0.293-0.707 '
  + 's0.442-0.293,0.707-0.293h0.001l17.28,0.02c0.552,0,0.999,0.447,0.999,1v2.973C315.372,856.561,314.26,857.672,312.892,857.672z '
  + 'M298.092,853.201v1.99c0,0.266,0.216,0.48,0.481,0.48h14.318c0.265,0,0.48-0.215,0.48-0.48v-1.975L298.092,853.201z '
  + 'M317.828,850.066L317.828,850.066l-23.698-0.01c-0.448,0-0.842-0.299-0.963-0.73s0.061-0.891,0.443-1.125l11.355-6.91 '
  + 'c0.307-0.186,0.692-0.195,1.009-0.018l12.343,6.92c0.396,0.223,0.594,0.686,0.479,1.125 C318.681,849.76,318.283,850.066,317.828,850.066z '
  + 'M297.694,848.059l16.303,0.006l-8.491-4.76L297.694,848.059z';

var ANDROID_HOME_WIDTH = 27;
var ANDROID_HOME_HEIGHT = 17;

/// 安卓菜单键路
var MENU = 'M193.238,843.354h-17.992c-0.553,0-1-0.447-1-1s0.447-1,1-1h17.992c0.553,0,1,0.447,1,1 S193.791,843.354,193.238,843.354z'
  + 'M193.238,848.082h-17.992c-0.553,0-1-0.447-1-1s0.447-1,1-1h17.992c0.553,0,1,0.447,1,1 S193.791,848.082,193.238,848.082z'
  + 'M193.238,853.117h-17.992c-0.553,0-1-0.447-1-1s0.447-1,1-1h17.992c0.553,0,1,0.447,1,1 S193.791,853.117,193.238,853.117z';

var MENU_WIDTH = 20;
var MENU_HEIGHT = 12;

/// 安卓返回键路
var BACK = 'M423.395,851.301c-0.219,0-0.439-0.072-0.624-0.219l-4.938-3.949c-0.237-0.191-0.375-0.479-0.375-0.781 '
  + 'c0-0.305,0.138-0.592,0.375-0.781l4.938-3.949c0.433-0.346,1.061-0.273,1.406,0.156c0.345,0.432,0.274,1.063-0.156,1.406 '
  + 'l-3.961,3.168l3.961,3.168c0.431,0.346,0.501,0.975,0.156,1.406C423.979,851.172,423.688,851.301,423.395,851.301z'
  + 'M432.282,856.729h-11.355c-0.553,0-1-0.447-1-1s0.447-1,1-1h11.355c2.035,0,3.69-1.654,3.69-3.689 c0-2.033-1.655-3.688-3.69-3.688h-11.355'
  + 'c-0.553,0-1-0.447-1-1s0.447-1,1-1h11.355c3.138,0,5.69,2.551,5.69,5.688 S435.42,856.729,432.282,856.729z';

var BACK_WIDTH = 21;
var BACK_HEIGHT = 16;

/// 安卓电量图标路
var ANDROID_BETTERY = 'M427.214,167.796h-1.1 c0.003-0.019,0.012-0.035,0.012-0.055c0-0.387-0.313-0.7-0.699-0.7h-1.646c-0.387,0-0.699,0.313-0.699,0.7 '
  + 'c0,0.02,0.009,0.036,0.011,0.055h-0.958c-0.576,0-1.044,0.467-1.044,1.044v6.945c0,0.577,0.468,1.044,1.044,1.044h5.08 '
  + 'c0.576,0,1.044-0.468,1.044-1.044v-6.945C428.258,168.264,427.79,167.796,427.214,167.796z';

/// IOS默认尺寸下外壳圆角
var IPHONE_RADIUS = 45;//60;

/// IOS默认尺寸下屏幕左边界
var IPHONE_BORDER_LEFT = 20;

/// IOS默认尺寸下屏幕上边界
var IPHONE_BORDER_TOP = 83;

/// IOS默认尺寸下屏幕右边界
var IPHONE_BORDER_RIGHT = 20;

/// IOS默认尺寸下屏幕下边界
var IPHONE_BORDER_BOTTOM = 83;

/// IOS默认宽度
var IPHONE_DEFAULT_WIDTH = 340;//425;

/// IOS默认高度
var IPHONE_DEFAULT_HEIGHT = 702;//876;

/// IOS默认尺寸下Home键尺寸
var IPHONE_BUTTONS_SIZE = 45;//55;

/// IOS默认尺寸下听筒高度
var IPHONE_HORM_HEIGHT = 6;//4

/// IOS默认尺寸下Mic尺寸
var IPHONE_MIC_SIZE = 6;//4

/// IOS默认尺寸下摄像头尺寸
var IPHONE_CAMERA_SIZE = 12;//6

/// IOS默认尺寸摄像头与听筒间距
var IPHONE_CAMERA_OFFSET = 27;

/// IOS默认尺寸下Mic与听筒间距
var IPHONE_MIC_OFFSET = 15;

/// IOS默认尺寸下高亮边框与整体的间距
var IPHONE_MARGIN = 0;//4;

/// Android默认宽度
var ANDROID_DEFAULT_WIDTH = 344;//420;

/// Android默认高度
var ANDROID_DEFAULT_HEIGHT = 702;//822;

/// Android默认尺寸下屏幕左边框
var ANDROID_BORDER_LEFT = 18;

/// Android默认尺寸下屏幕右边框
var ANDROID_BORDER_RIGHT = 18;

/// Android默认尺寸下屏幕上边框
var ANDROID_BORDER_TOP = 63;

/// Android默认尺寸下屏幕下边框
var ANDROID_BORDER_BOTTOM = 90;

/// Android默认尺寸下听筒高度
var ANDROID_HORM_HEIGHT = 6;//4

/// Android默认尺寸下听筒高度
var ANDROID_HORM_WIDTH = 64;

/// Android默认尺寸下摄像头与听筒间距
var ANDROID_CAMERA_OFFSET = 82;

/// Android默认尺寸下导航栏高度
var ANDROID_BUTTONS_HEIGHT = 15;

/// Android默认尺寸下导航栏宽度
var ANDROID_BUTTONS_WIDTH = 225;

/// IPad默认宽度
var IPAD_DEFAULT_WIDTH = 491; //884;

/// IPad默认高度
var IPAD_DEFAULT_HEIGHT = 702;//1264;

/// IPad默认尺寸下屏幕上边距
var IPAD_BORDER_TOP = 67;

/// IPad默认尺寸下屏幕左边距
var IPAD_BORDER_LEFT = 32;

/// IPad默认尺寸下屏幕右边距
var IPAD_BORDER_RIGHT = 32;

/// IPad默认尺寸下屏幕下边距
var IPAD_BORDER_BOTTOM = 67;

/// IPad默认尺寸下Home键尺寸
var IPAD_BUTTONS_SIZE = 45;//33

/// IPad默认尺寸下摄像头尺寸
var IPAD_CAMERA_SIZE = 8;//8

/// 平板默认宽度
var TABLET_DEFAULT_WIDTH = 521;//941;

/// 平板默认高度
var TABLET_DEFAULT_HEIGHT = 702;//1267;

/// 平板默认尺寸下屏幕左边距
var TABLET_BORDER_LEFT = 35;//61;

/// 平板默认尺寸下屏幕上边距
var TABLET_BORDER_TOP = 58;//105;

/// 平板默认尺寸下屏幕下边距
var TABLET_BORDER_BOTTOM = 68;//120;

/// 平板默认尺寸下屏幕右边距
var TABLET_BORDER_RIGHT = 35;//61;

/// 平板默认尺寸下听筒高度
var TABLET_HORM_HEIGHT = 6;

/// 平板默认尺寸下听筒宽度
var TABLET_HORM_WIDTH = 50;

/// 平板默认尺寸下摄像头与听筒间距
var TABLET_CAMERA_OFFSET = 155;

/// 平板默认尺寸下导航栏高度
var TABLET_BUTTONS_HEIGHT = 25;

/// 平板默认尺寸下导航栏宽度
var TABLET_BUTTOMS_WIDTH = 380;

function getDefaultSize(shellType) {
  switch (shellType) {
  case 'IPhone2':
    return {
      width: IPHONE_DEFAULT_WIDTH,
      height: IPHONE_DEFAULT_HEIGHT
    };
  case 'Android':
    return {
      width: ANDROID_DEFAULT_WIDTH,
      height: ANDROID_DEFAULT_HEIGHT
    };
  case 'IPad2':
    return {
      width: IPAD_DEFAULT_WIDTH,
      height: IPAD_DEFAULT_HEIGHT
    };
  case 'TabletPC2':
    return {
      width: TABLET_DEFAULT_WIDTH,
      height: TABLET_DEFAULT_HEIGHT
    }
  }
}

function getDefaultBorderMargin(shellType) {
  switch (shellType) {
  case 'IPhone2':
    return {
      left: IPHONE_BORDER_LEFT,
      top: IPHONE_BORDER_TOP,
      right: IPHONE_BORDER_RIGHT,
      bottom: IPHONE_BORDER_BOTTOM
    };
  case 'Android':
    return {
      left: ANDROID_BORDER_LEFT,
      top: ANDROID_BORDER_TOP,
      right: ANDROID_BORDER_RIGHT,
      bottom: ANDROID_BORDER_BOTTOM
    };
  case 'IPad2':
    return {
      left: IPAD_BORDER_LEFT,
      top: IPAD_BORDER_TOP,
      right: IPAD_BORDER_RIGHT,
      bottom: IPAD_BORDER_BOTTOM
    };
  case 'TabletPC2':
    return {
      left: TABLET_BORDER_LEFT,
      top: TABLET_BORDER_TOP,
      right: TABLET_BORDER_RIGHT,
      bottom: TABLET_BORDER_BOTTOM
    };
  }
}

function calculateNormalScale(scaleX, scaleY) {
  return Math.min(1, scaleX, scaleY);
}

/**
 * 计算内容区域
 * @param info
 * @returns {{left: *, top: *, right: *, bottom: *}}
 */
function calculateContentRect(info) {
  var lScaleX, lScaleY, lRect;
  var L, T, R, B;
  lScaleX = Math.min(info.scaleX, 1);
  lScaleY = Math.min(info.scaleY, 1);
  lRect = getDefaultBorderMargin(info.shellType); // TODO: set shell type
  if (info.direction === 'SmVert') {
    L = lRect.left * lScaleX;
    T = lRect.top * lScaleY;
    R = info.width - L;
    B = info.height - lRect.bottom * lScaleX;
  } else {
    L = lRect.top * lScaleX;
    T = lRect.left * lScaleX;
    R = info.width - lRect.bottom * lScaleX;
    B = info.height - T;
  }
  // TODO: RoundRect
  return {
    left: L,
    top: T,
    right: R,
    bottom: B,
    width: R - L,
    height: B - T
  }
}
var NewPhone = React.createClass({
  render: function () {
    var controlType = this.props.controlTypeID;
    var width = this.props.w;
    var height = this.props.h;
    var defaultSize = getDefaultSize(controlType);
    var scaleX, scaleY;
    if (this.isVertical()) {
      scaleX = width / defaultSize.width;
      scaleY = height / defaultSize.height;
    } else {
      scaleX = height / defaultSize.width;
      scaleY = width / defaultSize.height;
    }
    return (
      <div>
        <svg width={width} height={height} viewBox={"0 0 " + width + " " + height}>
          {this.renderShellBorder(scaleX, scaleY)}
          {this.renderComponents(scaleX, scaleY)}
        </svg>
        {this.props.fullScreen || this.renderStatusBar(scaleX, scaleY)}
      </div>
    );
  },
  renderShellBorder: function (scaleX, scaleY) {
    var width = ~~this.props.w;
    var height = ~~this.props.h;
    var normalScale = calculateNormalScale(scaleX, scaleY);

    var radius = normalScale * IPHONE_RADIUS;

    var screenRect = calculateContentRect({
      shellType: this.props.controlTypeID,
      width: width,
      height: height,
      scaleX: scaleX,
      scaleY: scaleY,
      direction: this.props.direction
    });
    this.screenRect = screenRect; // 这里设置了屏幕区域
    // FIXME: 中间屏幕区域的透明还没有处理
    /*试图区域透明控制*/
    var fillOpcity;
    var isTransparent = this.props.isTransparent;
    if (isTransparent) {
      fillOpcity = 0;
    }

    return (
      <g>
        <defs>
          {(this.props.controlTypeID == 'IPhone2') &&
          <clipPath id='viewArea'>
            <rect x='0' y='0' width='100%' height={screenRect.top}></rect>
            <rect x='0' y={screenRect.top + screenRect.bottom - screenRect.top} width='100%'
                  height={height - screenRect.bottom}></rect>
            <rect x='0' y='0' width={screenRect.left} height='100%'></rect>
            <rect x={screenRect.right} y='0' width={screenRect.left} height='100%'></rect>
          </clipPath>}
          {(this.props.controlTypeID == 'Android') &&
          <clipPath id='viewArea'>
            <rect x='0' y='0' width='100%' height={screenRect.top}></rect>
            <rect x='0' y={screenRect.top + screenRect.bottom - screenRect.top} width='100%'
                  height={height - screenRect.bottom}></rect>
            <rect x='0' y='0' width={screenRect.left} height='100%'></rect>
            <rect x={screenRect.right} y='0' width={screenRect.left} height='100%'></rect>
          </clipPath>}
        </defs>
        <rect x="0" y="0"
              width={width}
              height={height}
              rx={radius}
              ry={radius}
              fill={this.props.color}
              strokeWidth={1}
              stroke={styleHelper.getBorderColor(this.props)}/>
        <rect x={screenRect.left}
              y={screenRect.top}
              width={screenRect.right - screenRect.left}
              height={screenRect.bottom - screenRect.top}
              fill="#FFF"
              fillOpacity={fillOpcity}
              strokeWidth={1}
              stroke={styleHelper.getBorderColor(this.props)}
        />
      </g>
    );
  },
  renderComponents: function (scaleX, scaleY) {
    switch (this.props.controlTypeID) {
    case 'IPhone2':
      return this.renderIPhoneComponents(scaleX, scaleY);
    case 'Android':
      return this.renderAndroidPhone(scaleX, scaleY);
    case 'IPad2':
      return this.renderIpadComponent(scaleX, scaleY);
    case 'TabletPC2':
      return this.renderTablePCComponent(scaleX, scaleY);
    }
  },
  renderStatusBar: function (scaleX, scaleY) {
    switch (this.props.controlTypeID) {
    case 'IPhone2':
      return this.renderIPhoneStatusBar(scaleX, scaleY);
    }
  },

  renderIPhoneStatusBar: function (scaleX, scaleY) {
    var defaultWidth = 320;
    var defaultHeight = 22;
    var style = {
      position: 'absolute',
      top: this.screenRect.top,
      left: this.screenRect.left
    };
    var batteryOffset = this.screenRect.width - defaultWidth; // 电池信息横向位移
    if (this.screenRect.width <= 260) {
      var statusBarScaleY = this.screenRect.width / defaultWidth;
      style.transform = 'scaleY(' + statusBarScaleY + ')';
      style.top = style.top - defaultHeight * (1 - statusBarScaleY);
    }
    return (
      <svg width={this.screenRect.width} height={22} style={style}>
        <rect
          x="0"
          y="0"
          height="22"
          width="100%"
          fill="#000"
        />
        <circle
          cx="6"
          cy="50%"
          r="3"
          fill="#FFF"
          stroke="#FFF"
        />
        <circle
          cx="15"
          cy="50%"
          r="3"
          fill="#FFF"
          stroke="#FFF"
        />
        <circle
          cx="24"
          cy="50%"
          r="3"
          fill="#FFF"
          stroke="#FFF"
        />
        <circle
          cx="33"
          cy="50%"
          r="3"
          fill="#000"
          stroke="#FFF"
        />
        <circle
          cx="42"
          cy="50%"
          r="3"
          fill="#000"
          stroke="#FFF"
        />
        <text
          x="52"
          y="16"
          fill="#FFF"
          fontSize="12"
          transform="scale(1)">Mockplus
        </text>
        <text
          x="50%"
          y="16"
          fill="#FFF"
          textAnchor="middle"
          fontSize="12">12:00AM
        </text>
        <text
          x={250 + batteryOffset}
          y="16"
          fill="#FFF"
          fontSize="12">
          100%
        </text>
        <rect
          x={286 + batteryOffset}
          y="6"
          width="24"
          height="11"
          fill="#000"
          strokeWidth="2"
          stroke="#FFF"
        />
        <rect
          x={288 + batteryOffset}
          y="9"
          width="20"
          height="5"
          fill="#FFF"
        />
        <rect
          x={310 + batteryOffset}
          y="10"
          width="4"
          height="4"
          fill="#FFF"
        />
      </svg>);
  },

  renderIPhoneComponents: function (scaleX, scaleY) {
    var lScale = calculateNormalScale(scaleX, scaleY);
    var width = ~~this.props.w;
    var height = ~~this.props.h;

    var homeButtonX, homeButtonY;
    var homeButtonSize = IPHONE_BUTTONS_SIZE * lScale; // home 键大小

    var receiverWidth, receiverHeight, receiverX, receiverY, receiverRadius;
    var cameraX, cameraY;

    var offset;

    var cameraRadius = IPHONE_CAMERA_SIZE * lScale / 2;
    var lightRadius = IPHONE_MIC_SIZE * lScale / 2;
    var lightX, lightY;

    if (this.isVertical()) {
      homeButtonX = (width - homeButtonSize) / 2;
      homeButtonY = this.screenRect.bottom + (height - this.screenRect.bottom - homeButtonSize) / 2;

      receiverWidth = homeButtonSize; // 听筒宽度
      receiverHeight = IPHONE_HORM_HEIGHT * lScale;
      receiverRadius = receiverHeight / 2;
      receiverX = (width - receiverWidth) / 2;
      receiverY = (this.screenRect.top - receiverHeight) / 2 + IPHONE_MARGIN * lScale;
      offset = (IPHONE_CAMERA_SIZE - IPHONE_HORM_HEIGHT) * lScale * 0.5;

      cameraX = receiverX - IPHONE_CAMERA_OFFSET * lScale + cameraRadius;
      cameraY = receiverY - offset + cameraRadius;

      lightX = (width - IPHONE_MIC_SIZE * scaleX) / 2;
      lightY = receiverY - IPHONE_MIC_OFFSET * lScale;
    } else {
      homeButtonX = this.screenRect.right + (width - this.screenRect.right - homeButtonSize) / 2;
      homeButtonY = (height - homeButtonSize) / 2;

      receiverWidth = IPHONE_HORM_HEIGHT * lScale;
      receiverHeight = homeButtonSize;
      receiverRadius = receiverWidth / 2;
      receiverX = (this.screenRect.left - receiverWidth) / 2 + IPHONE_MARGIN * lScale;
      receiverY = homeButtonY;

      offset = (IPHONE_CAMERA_SIZE - IPHONE_HORM_HEIGHT) * lScale * 0.5;

      cameraX = receiverX - offset + cameraRadius;
      cameraY = receiverY + homeButtonSize + IPHONE_CAMERA_OFFSET * lScale;

      lightX = receiverX - IPHONE_MIC_OFFSET * lScale + lightRadius;
      lightY = (height - IPHONE_MIC_SIZE * scaleX) / 2 + lightRadius;
    }
    var startLeft = 5 * lScale;
    var circles = [];
    var circleRadius = 6 * lScale / 2;
    var circleY = 10;
    var circleFillColor = '';
    for (var i = 0; i < 5; i++) {
      if (i < 3) { // 实心
        circleFillColor = '#FFF';
      } else {
        circleFillColor = '';
      }
      circles.push(<circle
        cx={startLeft + circleRadius}
        cy={circleY}
        r={circleRadius}
        fill={circleFillColor}
        stroke="#FFF"
      />);
      startLeft = startLeft + circleRadius * 2 + 2.5;
    }

    /*状态控制*/
    var phoneType = this.props.phoneType;
    var phoneTypeState;
    var isTransparent = this.props.isTransparent;
    var fillOpacity;
    var rectTop, rectHeight;
    if (isTransparent) {
      fillOpacity = 0;
    } else {
      fillOpacity = 1;
    }
    if (this.props.fullScreen) {
      rectTop = this.screenRect.top;
      rectHeight = this.screenRect.bottom - this.screenRect.top
    } else {
      rectTop = this.screenRect.top + 20 * lScale;
      rectHeight = this.screenRect.bottom - this.screenRect.top - 20 * lScale;
    }
    if (phoneType === 'PtTopOnly') {
      phoneTypeState = (
        <g>
          <rect
            x={this.screenRect.left}
            y={this.screenRect.top + 20 * lScale}
            height={40 * lScale}
            width={width - 2 * this.screenRect.left}
            fill='#fff'
            fillOpacity={fillOpacity}
            stroke='#000'
          />
        </g>
      )
    } else if (phoneType === 'PtTopAndBottom') {
      phoneTypeState = (
        <g>
          <rect
            x={this.screenRect.left}
            y={this.screenRect.top + 20 * lScale}
            height={40 * lScale}
            width={width - 2 * this.screenRect.left}
            fill='#fff'
            fillOpacity={fillOpacity}
            stroke='#000'
          />
          <rect
            x={this.screenRect.left}
            y={this.screenRect.top + this.screenRect.bottom - this.screenRect.top - 40 * lScale}
            height={40 * lScale}
            width={width - 2 * this.screenRect.left}
            fill='#fff'
            fillOpacity={fillOpacity}
            stroke='#000'
          />
        </g>
      )
    } else if (phoneType === 'PtAllBlack') {
      phoneTypeState = (
        <g>
          <rect
            x={this.screenRect.left}
            y={rectTop}
            height={rectHeight}
            width={width - 2 * this.screenRect.left}
            fill='#3f3f3f'
            fillOpacity={fillOpacity}
          />
        </g>
      )
    }
    return (
      <g>
        <rect
          x={homeButtonX}
          y={homeButtonY}
          width={homeButtonSize}
          height={homeButtonSize}
          rx={homeButtonSize}
          ry={homeButtonSize}
          fill={this.props.color}
          stroke={this.getColor()}
          strokeWidth={2}
        />
        <rect
          x={receiverX}
          y={receiverY}
          width={receiverWidth}
          height={receiverHeight}
          rx={receiverRadius}
          ry={receiverRadius}
          fill={this.getColor()}
        />
        <circle
          cx={cameraX}
          cy={cameraY}
          r={cameraRadius}
          fill={this.getColor()}
        />
        <circle
          cx={lightX}
          cy={lightY}
          r={lightRadius}
          fill={this.getColor()}
        />
        {phoneTypeState}
      </g>
    );
  },

  renderIpadComponent(scaleX, scaleY){
    var lScale = calculateNormalScale(scaleX, scaleY);
    var width = ~~this.props.w;
    var height = ~~this.props.h;
    var homeButtonX, homeButtonY;
    var homeButtonSize = IPAD_BUTTONS_SIZE * lScale; //Home 尺寸大小
    var cameraX, cameraY;
    var cameraRadius = IPAD_CAMERA_SIZE * lScale / 2;
    if (this.isVertical()) {
      homeButtonX = (width - homeButtonSize) / 2;
      homeButtonY = this.screenRect.bottom + (height - this.screenRect.bottom - homeButtonSize) / 2;

      cameraX = (width - cameraRadius) / 2;
      cameraY = (this.screenRect.top + cameraRadius) / 2;
    } else {
      homeButtonX = this.screenRect.right + (width - this.screenRect.right - homeButtonSize) / 2;
      homeButtonY = (height - homeButtonSize) / 2;

      cameraX = (this.screenRect.left + cameraRadius) / 2;
      cameraY = (height - cameraRadius) / 2;
    }
    return (
      <g>
        <rect
          x={homeButtonX}
          y={homeButtonY}
          width={homeButtonSize}
          height={homeButtonSize}
          rx={homeButtonSize}
          ry={homeButtonSize}
          fill={this.props.color}
          stroke={this.getColor()}
          strokeWidth={2 * lScale}
        />
        <circle
          cx={cameraX}
          cy={cameraY}
          r={cameraRadius * lScale}
          fill={this.getColor()}
        />
      </g>
    )
  },

  renderAndroidPhone: function (scaleX, scaleY) {
    var lScale = calculateNormalScale(scaleX, scaleY);

    var lScaleX = Math.min(1, scaleX);
    var lScaleY = Math.min(1, scaleY);
    var normalScale = calculateNormalScale(scaleX, scaleY);
    var width = ~~this.props.w;
    var height = ~~this.props.h;

    var receiverX, receiverY, receiverWidth, receiverHeight, receiverRadius;

    var cameraX, cameraY, cameraRadius;

    var rect;

    var menuX, menuY, menuStyle;
    var homeX, homeY, homeStyle;
    var backX, backY, backStyle;
    var buttonsY;

    var L, T, B, R;

    var statusBar;

    if (this.isVertical()) {
      receiverWidth = ANDROID_HORM_WIDTH * scaleX;
      receiverHeight = ANDROID_HORM_HEIGHT * lScaleY;
      receiverX = (width - receiverWidth) / 2;
      receiverY = ANDROID_BORDER_TOP * lScaleY / 2 - receiverHeight;
      receiverRadius = receiverHeight / 2;

      cameraRadius = receiverHeight;
      cameraX = receiverX + receiverWidth + ANDROID_CAMERA_OFFSET * scaleX + cameraRadius;
      cameraY = receiverY + cameraRadius;

      L = (width - ANDROID_BUTTONS_WIDTH * scaleX) / 2;
      T = height - ANDROID_BORDER_BOTTOM * lScaleY;
      T = T + (ANDROID_BORDER_BOTTOM - ANDROID_BUTTONS_HEIGHT) * 0.5 * lScaleY;
      B = T + ANDROID_BUTTONS_HEIGHT * lScaleY;
      R = width - L;

      rect = {
        left: L,
        top: T,
        bottom: B,
        right: R,
        width: R - L,
        height: B - T
      };

      menuX = rect.left;
      buttonsY = rect.top + (rect.height - MENU_HEIGHT) / 2;
      menuStyle = {
        transform: "translate(" + (-174 + menuX) + "px," + (-841 + buttonsY) + "px) scale(" + normalScale + ")",
        transformOrigin: "center"
      };

      homeX = (width - ANDROID_HOME_WIDTH) / 2;
      homeStyle = {
        transform: "translate(" + (-293 + homeX) + "px," + (-841 + buttonsY) + "px) scale(" + normalScale + ")",
        transformOrigin: "center"
      };

      backX = rect.right - BACK_WIDTH;
      backStyle = {
        transform: "translate(" + (-418 + backX) + "px," + (-841 + buttonsY) + "px) scale(" + normalScale + ")",
        transformOrigin: "center"
      };
    } else {
      receiverWidth = ANDROID_HORM_HEIGHT * lScaleY;
      receiverHeight = ANDROID_HORM_WIDTH * lScaleX;
      receiverX = ANDROID_BORDER_TOP * lScaleY / 2 - receiverWidth;
      receiverY = (height - receiverHeight) / 2;
      receiverRadius = receiverWidth / 2;

      cameraRadius = receiverWidth;
      cameraX = receiverX + cameraRadius;
      cameraY = receiverY - ANDROID_CAMERA_OFFSET * scaleX;

      T = (height - ANDROID_BUTTONS_WIDTH * scaleX) / 2;
      L = width - ANDROID_BORDER_BOTTOM * lScaleY;
      L = L + (ANDROID_BORDER_BOTTOM - ANDROID_BUTTONS_HEIGHT) * 0.5 * lScaleY;
      B = height - T;
      R = L + ANDROID_BUTTONS_HEIGHT * lScaleY;

      rect = {
        left: L,
        top: T,
        bottom: B,
        right: R,
        width: R - L,
        height: B - T,
        center: {
          x: L + (R - L) / 2,
          y: T + (B - T) / 2
        }
      };

      backX = rect.center.x - BACK_WIDTH / 2;
      backY = rect.top;
      backStyle = {
        transform: "translate(" + (-418 + backX) + "px," + (-841 + backY) + "px) rotate(270deg) scale(" + normalScale + ")",
        transformOrigin: "center"
      };

      homeX = rect.center.x - ANDROID_HOME_WIDTH / 2;
      homeY = rect.center.y - ANDROID_HOME_HEIGHT / 2;
      homeStyle = {
        transform: "translate(" + (-293 + homeX) + "px," + (-841 + homeY) + "px) rotate(270deg) scale(" + normalScale + ")",
        transformOrigin: "center"
      };

      menuX = rect.center.x - MENU_WIDTH / 2;
      menuY = rect.bottom - MENU_HEIGHT;
      menuStyle = {
        transform: "translate(" + (-174 + menuX) + "px," + (-841 + menuY) + "px) rotate(270deg) scale(" + normalScale + ")",
        transformOrigin: "center"
      };
    }

    var statusBarOffsetHeight = this.screenRect.top + 6;
    statusBar = (
      <g>
        <rect
          x={this.screenRect.left}
          y={this.screenRect.top}
          width={this.screenRect.width}
          height={20 * normalScale}
          fill="#040000"
        />
        <text
          x={this.screenRect.right - 54 * normalScale}
          y={this.screenRect.top + 16 * normalScale}
          fontSize={10 * normalScale}
          fill="#FFF"
        >
          12:00AM
        </text>
        <path
          d={ANDROID_BETTERY}
          fill="#FFF"
          transform={"translate(" + (-421 + this.screenRect.right - 66) + "," + (-167 + statusBarOffsetHeight) + ")"}
        />
        <line
          x1={this.screenRect.right - 71}
          y1={statusBarOffsetHeight}
          x2={this.screenRect.right - 71}
          y2={statusBarOffsetHeight + 10}
          stroke="#FFF"
          strokeWidth={2}
        />
        <line
          x1={this.screenRect.right - 74}
          y1={statusBarOffsetHeight + 3 }
          x2={this.screenRect.right - 74}
          y2={statusBarOffsetHeight + 10}
          stroke="#FFF"
          strokeWidth={2}
        />
        <line
          x1={this.screenRect.right - 77}
          y1={statusBarOffsetHeight + 6 }
          x2={this.screenRect.right - 77}
          y2={statusBarOffsetHeight + 10}
          stroke="#FFF"
          strokeWidth={2}
        />
        <line
          x1={this.screenRect.right - 80}
          y1={statusBarOffsetHeight + 8 }
          x2={this.screenRect.right - 80}
          y2={statusBarOffsetHeight + 10}
          stroke="#FFF"
          strokeWidth={2}
        />
        <path
          transform={"translate(" + (-232 + this.screenRect.right - 96) + "," + (-171 + statusBarOffsetHeight) + ")"}
          d={WIFI}
          fill="#FFF"
        />
      </g>
    );
    /*状态控制*/
    var phoneType = this.props.phoneType;
    var phoneTypeState;
    var isTransparent = this.props.isTransparent;
    var fillOpacity;
    var rectTop, rectHeight;
    if (isTransparent) {
      fillOpacity = 0;
    } else {
      fillOpacity = 1;
    }
    var fullScreen = this.props.fullScreen;
    if (fullScreen) {
      rectTop = this.screenRect.top;
      rectHeight = this.screenRect.bottom - this.screenRect.top
    } else {
      rectTop = this.screenRect.top + 20 * lScale;
      rectHeight = this.screenRect.bottom - this.screenRect.top - 20 * lScale;
    }
    if (phoneType === 'PtTopOnly') {
      phoneTypeState = (
        <g>
          <rect
            x={this.screenRect.left}
            y={this.screenRect.top + 20 * lScale}
            height={40 * lScaleY}
            width={this.screenRect.width}
            fill='#fff'
            fillOpacity={fillOpacity}
            stroke='#000'
          />
        </g>
      )
    } else if (phoneType === 'PtTopAndBottom') {
      phoneTypeState = (
        <g>
          <rect
            x={this.screenRect.left}
            y={this.screenRect.top + 20 * lScale}
            height={40 * lScale}
            width={width - 2 * this.screenRect.left}
            fill='#fff'
            fillOpacity={fillOpacity}
            stroke='#000'
          />
          <rect
            x={this.screenRect.left}
            y={this.screenRect.top + this.screenRect.bottom - this.screenRect.top - 40 * lScale}
            height={40 * lScale}
            width={width - 2 * this.screenRect.left}
            fill='#fff'
            fillOpacity={fillOpacity}
            stroke='#000'
          />
        </g>
      )
    } else if (phoneType === 'PtAllBlack') {
      phoneTypeState = (
        <g>
          <rect
            x={this.screenRect.left}
            y={rectTop}
            height={rectHeight}
            width={this.screenRect.width}
            fill='#3f3f3f'
            fillOpacity={fillOpacity}
          />
        </g>
      )
    }

    /*全屏控制*/
    var fullScreen = this.props.fullScreen;
    if (fullScreen) {
      statusBar = null;
    }
    return (
      <g>
        <rect
          x={receiverX}
          y={receiverY}
          rx={receiverRadius}
          ry={receiverRadius}
          width={receiverWidth}
          height={receiverHeight}
          fill={this.getColor()}
        />
        <circle
          cx={cameraX}
          cy={cameraY}
          r={cameraRadius}
          fill={this.getColor()}
        />
        <path d={MENU}
              style={menuStyle}
              fill={this.getColor()}
        />
        <path d={ANDROID_HOME}
              style={homeStyle}
              fill={this.getColor()}
        />
        <path d={BACK}
              style={backStyle}
              fill={this.getColor()}
        />
        {statusBar}
        {phoneTypeState}
      </g>
    );
  },

  renderTablePCComponent(scaleX, scaleY){
    var lScaleX = Math.min(1, scaleX);
    var lScaleY = Math.min(1, scaleY);
    var normalScale = calculateNormalScale(scaleX, scaleY);
    var width = ~~this.props.w;
    var height = ~~this.props.h;

    var receiverX, receiverY, receiverWidth, receiverHeight, receiverRadius;

    var cameraX, cameraY, cameraRadius;

    var rect;

    var menuX, menuY, menuStyle;
    var homeX, homeY, homeStyle;
    var backX, backY, backStyle;

    var L, T, B, R;

    if (this.isVertical()) {
      receiverWidth = TABLET_HORM_WIDTH * scaleX;
      receiverHeight = TABLET_HORM_HEIGHT * lScaleY;
      receiverX = (width - receiverWidth) / 2;
      receiverY = TABLET_BORDER_TOP * lScaleY / 2 - receiverHeight;
      receiverRadius = receiverHeight / 2;

      cameraRadius = receiverHeight;
      cameraX = receiverX + receiverWidth + TABLET_CAMERA_OFFSET * scaleX + cameraRadius;
      cameraY = receiverY + cameraRadius;

      L = (width - TABLET_BUTTOMS_WIDTH * scaleX) / 2;
      T = height - TABLET_BORDER_BOTTOM * lScaleY;
      T = T + (TABLET_BORDER_BOTTOM - TABLET_BUTTONS_HEIGHT) * 0.5 * lScaleY;
      B = T + TABLET_BUTTONS_HEIGHT * lScaleY;
      R = width - L;

      rect = {
        left: L,
        top: T,
        bottom: B,
        right: R,
        width: R - L,
        height: B - T
      };

      menuX = rect.left;
      menuY = rect.top + (rect.height - MENU_HEIGHT) / 2;
      menuStyle = {
        transform: "translate(" + (-174 + menuX) + "px," + (-841 + menuY) + "px) scale(" + normalScale + ")",
        transformOrigin: "center"
      };

      homeX = (width - ANDROID_HOME_WIDTH) / 2;
      homeY = rect.top + (rect.height - ANDROID_HOME_HEIGHT) / 2;
      homeStyle = {
        transform: "translate(" + (-293 + homeX) + "px," + (-841 + menuY) + "px) scale(" + normalScale + ")",
        transformOrigin: "center"
      };

      backX = rect.right - BACK_WIDTH;
      backY = rect.top + (rect.height - BACK_HEIGHT);
      backStyle = {
        transform: "translate(" + (-418 + backX) + "px," + (-841 + menuY) + "px) scale(" + normalScale + ")",
        transformOrigin: "center"
      };
    } else {
      receiverWidth = TABLET_HORM_HEIGHT * lScaleY;
      receiverHeight = TABLET_HORM_WIDTH * lScaleX;
      receiverX = TABLET_BORDER_TOP * lScaleY / 2 - receiverWidth;
      receiverY = (height - receiverHeight) / 2;
      receiverRadius = receiverWidth / 2;
      cameraRadius = receiverWidth;
      cameraX = receiverX + cameraRadius;
      cameraY = receiverY - TABLET_CAMERA_OFFSET * scaleX;

      T = (height - TABLET_BUTTOMS_WIDTH * scaleX) / 2;
      L = width - TABLET_BORDER_BOTTOM * lScaleY;
      L = L + (TABLET_BORDER_BOTTOM - TABLET_BUTTONS_HEIGHT) * 0.5 * lScaleY;
      B = height - T;
      R = L + TABLET_BUTTONS_HEIGHT * lScaleY;

      rect = {
        left: L,
        top: T,
        bottom: B,
        right: R,
        width: R - L,
        height: B - T,
        center: {
          x: L + (R - L) / 2,
          y: T + (B - T) / 2
        }
      };

      backX = rect.center.x - BACK_WIDTH / 2;
      backY = rect.top;
      backStyle = {
        transform: "translate(" + (-418 + backX) + "px," + (-841 + backY) + "px) rotate(270deg) scale(" + normalScale + ")",
        transformOrigin: "center"
      };

      homeX = rect.center.x - ANDROID_HOME_WIDTH / 2;
      homeY = rect.center.y - ANDROID_HOME_HEIGHT / 2;
      homeStyle = {
        transform: "translate(" + (-293 + homeX) + "px," + (-841 + homeY) + "px) rotate(270deg) scale(" + normalScale + ")",
        transformOrigin: "center"
      };

      menuX = rect.center.x - MENU_WIDTH / 2;
      menuY = rect.bottom - MENU_HEIGHT;
      menuStyle = {
        transform: "translate(" + (-174 + menuX) + "px," + (-841 + menuY) + "px) rotate(270deg) scale(" + normalScale + ")",
        transformOrigin: "center"
      };
    }

    return (
      <g>
        <rect
          x={receiverX}
          y={receiverY}
          rx={receiverRadius}
          ry={receiverRadius}
          width={receiverWidth}
          height={receiverHeight}
          fill={this.getColor()}
        />
        <circle
          cx={cameraX}
          cy={cameraY}
          r={cameraRadius * scaleX}
          fill={this.getColor()}
        />
        <path d={MENU}
              style={menuStyle}
              fill={this.getColor()}
        />
        <path d={ANDROID_HOME}
              style={homeStyle}
              fill={this.getColor()}
        />
        <path d={BACK}
              style={backStyle}
              fill={this.getColor()}
        />
      </g>
    );
  },

  isVertical: function () {
    return this.props.direction === 'SmVert';
  },
  getColor: function () {
    return '#808080';
  }
});

module.exports = NewPhone;



// WEBPACK FOOTER //
// ./src/views/Components/NewPhone.jsx